import z from 'zod';
import { ManufacturerDocumentFileSchema } from './ManufacturerDocumentFile';

export const ManufacturerDocumentsResultSchema = z.object({
    data: z.array(ManufacturerDocumentFileSchema),
    total: z.number(),
});

export type ManufacturerDocumentsResult = z.infer<typeof ManufacturerDocumentsResultSchema>;
